import Backbone from 'backbone';
import Panel from './Panel';

export default Backbone.Collection.extend({
  model: Panel
});



// WEBPACK FOOTER //
// webpack://grapesjs/src/panels/model/Panels.js